
import { Vue, Component } from 'vue-property-decorator';
import { AvailableLoan } from '@/interfaces/loan';
import LoanInCollectionDialog from '@/components/Loans/Collections/Dialogs/LoanInCollectionDialog.vue';

@Component
export default class AuthenticatedView extends Vue {
  isLoaded = false;

  async mounted() {
    try {
      await this.$store.dispatch('User/fetchUserInfo');

      if (!this.hasOnlyRepayLoans) { // fetch payment methods only for non repay consumers
        await this.$store.dispatch('PaymentOptions/getPaymentOptions');

        if (!this.hasPaymentMethods && this.$route.name !== 'payment-setup') {
          await this.$router.push({ name: 'payment-setup' });
        }
      }
    } catch {
      await this.$router.push({ name: 'error' });
    } finally {
      this.isLoaded = true;
    }

    if (this.firstLoanInCollection) {
      // show collection agency dialog only for single loans
      this.$dialog({
        component: LoanInCollectionDialog,
        props: { loan: this.firstLoanInCollection }
      });
    }
  }

  get hasPaymentMethods(): boolean {
    return this.$store.getters['User/hasPaymentMethods'];
  }

  get hasOnlyRepayLoans(): boolean {
    return this.$store.getters['User/availableLoans'].every((l: AvailableLoan) => !l.is_visible);
  }

  get firstLoanInCollection(): AvailableLoan | undefined {
    return this.$store.getters['User/loansInCollection'].at(0);
  }
}
